var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardMedia } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ECardHeight } from "../../enums";
export var CardWithShadow = React.forwardRef(function (props, ref) {
    var _a;
    var isDoubleWidth = props.isDoubleWidth, cardHeight = props.cardHeight, fullSizeImageUrl = props.fullSizeImageUrl, fullSizeImageHideOverlay = props.fullSizeImageHideOverlay, cardHeightOverride = props.cardHeightOverride, fixedWidth = props.fixedWidth;
    var _b = useState(1), scale = _b[0], setScale = _b[1];
    var _c = useState({}), shadow = _c[0], setShadow = _c[1];
    var _d = useState(!!isDoubleWidth), _isDoubleWidth = _d[0], setIsDoubleWidth = _d[1];
    var _e = useState(360), height = _e[0], setHeight = _e[1];
    useEffect(function () {
        setIsDoubleWidth(!!isDoubleWidth);
    }, [isDoubleWidth]);
    useEffect(function () {
        if (cardHeightOverride) {
            setHeight(cardHeightOverride);
        }
    }, [cardHeightOverride]);
    useEffect(function () {
        if (cardHeight) {
            switch (cardHeight) {
                case ECardHeight.NORMAL:
                    setHeight(360);
                    break;
                case ECardHeight.SQUARED:
                    setHeight(331);
                    break;
                case ECardHeight.TICKER:
                    setHeight(226);
                    break;
                case ECardHeight.MATCH_ROW:
                    setHeight(120);
                    break;
                case ECardHeight.UNSET:
                    setHeight("unset");
                    break;
            }
        }
    }, [cardHeight]);
    useEffect(function () {
        if (!!props.setScale) {
            props.setScale(scale);
        }
    }, [scale]);
    var onMouseEnter = function (e) {
        if (!props.disableOnHoverActions) {
            setShadow({ boxShadow: "0 14px 28px rgb(0 0 0 / 10%), 0 10px 10px rgb(0 0 0 / 10%)" });
            setScale(props.onHoverScale || 1.08);
        }
        props.onMouseEnter && props.onMouseEnter(e);
    };
    var onMouseLeave = function (e) {
        if (!props.disableOnHoverActions) {
            setShadow({});
            setScale(1);
        }
        props.onMouseLeave && props.onMouseLeave(e);
    };
    var handleCardClick = function (e) {
        if (props.onClickSpecialAction) {
            props.onClickSpecialAction(e);
        }
    };
    return (_jsxs(Card, __assign({ style: props.style, component: (props.onClickSpecialAction !== undefined || !props.to) ? "div" : Link, to: props.to, viewTransition: true, target: ((_a = props.to) === null || _a === void 0 ? void 0 : _a.startsWith("https://")) ? "_blank" : undefined, sx: __assign(__assign({ boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.12)", backgroundColor: "background.default", borderRadius: "8px", height: height, width: fixedWidth !== null && fixedWidth !== void 0 ? fixedWidth : "unset", position: !!fullSizeImageUrl ? "relative" : null, cursor: !!props.onClickSpecialAction || !!props.to ? "pointer" : "default", textDecoration: "none" }, shadow), props.sx), onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: handleCardClick, ref: ref }, { children: [!!fullSizeImageUrl && _jsxs(_Fragment, { children: [_jsx(CardMedia, { component: "div", sx: {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundImage: fullSizeImageUrl.startsWith("url(") ? fullSizeImageUrl : "url(".concat(fullSizeImageUrl, ")"),
                            backgroundSize: "cover",
                            transform: "scale(".concat(scale, ")"),
                            transition: "transform 1.5s",
                        } }), !fullSizeImageHideOverlay &&
                        _jsx("div", { style: {
                                backgroundImage: "linear-gradient(to bottom,rgba(0, 0, 0, 0) 60%,rgba(0, 0, 0, 0.8))",
                                zIndex: 0,
                                position: "absolute", top: 0, left: 0, right: 0, bottom: 0
                            } })] }), props.children] })));
});
